export default __webpack_public_path__ + "bash.395e9eb9.png";